<template>
  <div class="page">
    <StaticHeader v-bind:title="$root.t(`editor:title:${$route.params.editor}`)"/>
    <div class="container container-nopaddinghorizontal container-afterheader container-includestaticfooter">
      <transition name="container-overlay">
        <div class="container-overlay" v-if="searching"></div>      
      </transition>      

      <div class="container container-small container-float">
        <div class="container-column container-column-left" v-html="$root.t(`editor:column_left:${$route.params.editor}`)"></div>
        <div class="container-column container-column-right" v-html="$root.t(`editor:column_right:${$route.params.editor}`)"></div>
      </div>

      <form v-on:submit.prevent="submit()">
        <div class="container page-submitarea" :class="{'page-submitarea-fixed': $root.isScrolledMore}">
          <div class="container container-small">
            <input class="wide wide-left wide-third" type="submit" :value="$root.t('editor:submit')">
            <router-link tag="input" class="wide wide-middle wide-third" type="submit" :to="`/${form_type}/${$route.params.id}`" :value="$root.t('profile:openentry')"></router-link>
            <input class="wide wide-right wide-third" type="submit" v-on:click.prevent="close()" :value="$root.t('editor:close')">
          </div>
        </div>
        <div class="container container-small page-fields" v-if="form_data">
          <div class="statecontainer" :class="`statecontainer statecontainer-${data.Contribution.Status}`">
            <input type="submit" v-on:click.prevent="toggleState(data.Contribution.Status)" :value="$root.t(`editor:changevisibility:${data.Contribution.Status}`)">
            <p v-html="$root.t(`editor:visibility:${data.Contribution.Status}`)"></p>
          </div> 
          <EditorFormField v-bind:values="form_data" v-bind:data="form_field" v-bind:model.sync="form_data"/>
        </div>
      </form>
    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .page {
      &-content {
          & > h1 {
              margin-top: $base-size * 2;
          }
          & > div {
              max-width: 660px;
              hyphens: auto;
              text-align: justify;
          }
      }
      &-submitarea {
        position: absolute !important; 
        z-index: 3; 
        width: 100%; 
        padding: 0; 
        & > .container-small {
          width: 100%;
          padding: 0 $padding !important;
          @include dt() {
            padding: 0 !important;
          }
          text-align: center;
          & > input {
             margin: 0;
             &.wide {
               &-third {
                 width: calc(33.3% - 0.5em);
               }
               &-middle {
                 display: inline;
                 float: left;
                 margin-left: 0.75em;
               }
               @include sm() {
                 @include smallfont();
               }
             }
          }
        }
        &-fixed {
          top: 4em; 
          position: fixed !important; 
          background:  $inactive-color;
        }
      }
      &-fields {
         padding-top: 5em !important;
      }
  }

</style>

<script>

import EditorFormField from '@/components/EditorFormField.vue'
import StaticHeader from '@/components/StaticHeader.vue'
import StaticFooter from '@/components/StaticFooter.vue'


export default {
  name: 'editor',
  components: {
      StaticHeader,
      StaticFooter,
      EditorFormField
  },
  data() {
    return {
        data: null,
        searching: true,
        form_data: false,
        form_type: "",
        form_field: [],
        debounce: {},
        autocomplete_providers: {
            autor           : this.person_provider,     
            coautor         : this.person_provider,
            herausgeber     : this.person_provider,
            uebersetzer     : this.person_provider,
            werkref         : this.werk_provider,
            werk            : this.werk_provider
        },
        autocomplete_templates: {
            autor           : this.person_template,     
            coautor         : this.person_template,
            herausgeber     : this.person_template,
            uebersetzer     : this.person_template,
            werkref         : this.werk_template
        },
        formfield_exceptions: {
            intitel         : 'Textarea',
            notes           : 'Textarea',
            info            : 'Textarea',
            ausgaben        : 'Textarea',
            adslexid        : 'Hidden',
            genre           : 'TypologySelectMultiple',
            63              : 'Hidden',
            36              : 'Hidden',
            32              : 'Hidden', // Intitel
        },
        label_exceptions  : {
            64              : 'SecondaryWorkRef',
            65              : 'SecondaryAutorLabel',
            60              : 'MediaNotesLabel',
            47              : 'MediaInfoLabel',
            55              : 'MediaAutorLabel',
        },
        forminfo_exceptions: {
            64              : 'SecondaryWorkRefInfo',
            62              : 'WorkRefInfo',
            61              : 'MediaWorkRefInfo',
            60              : 'MediaNotesInfo',
            47              : 'MediaInfo',
            genre           : 'GenreNotesInfo',
            isbn            : 'ISBNInfo',
            31              : 'BookNotesInfo',
            65              : 'SekAutorInfo',
            55              : 'MediaAutorInfo',
            40              : 'BookAutorInfo'
        },
        grouptitle_exception: {
          40                : 'BookAutorTitle',
          29                : 'BookInfoTitle'
        },
        groupdivider_exception: {
          43                : true
        }
    }
  },
  mounted() {
    if (!this.$root.logindata.token) {
      this.$root.loginmodal(this.fetchData);
    } else {
      this.fetchData()
    }
  },
  watch: {
    '$route' () {
        this.fetchData(); 
    }
  },
  methods: {
    async werk_provider(form_field, event) {
      if (!event.target.value || event.target.value == "") {
        form_field.value = [];
        if (this.debounce[form_field.id]) {
          clearTimeout(this.debounce[form_field.id]);
        }
        return;
      }
      if (this.debounce[form_field.id]) {
        clearTimeout(this.debounce[form_field.id]);
      }
      this.debounce[form_field.id] = setTimeout((async()=>{
        form_field.value = await this.$store.dispatch('load', {mode: "/contributions/3/4-5-10", params: {
            limit: 5,
            query: event.target.value,
            verbose: "true",
            data: "autor|titel|untertitel"
        }});
        try {
          form_field.value.Documents.forEach((d)=>{
            d._html = `${d.Data.autor.Reference?`${d.Data.autor.Reference[d.Data.autor.Field.Content[0]].__contribution__.Name}: `:''}${d.Data.titel.Field.Content}${d.Data.untertitel&&d.Data.untertitel.Field.Content ? `, ${d.Data.untertitel.Field.Content}`:''}`
          })
        } catch (error) {
          
        } 
      }).bind(this, form_field, event), 500);
    },
    werk_template(field) {
      return `${field.autor.Reference?`${field.autor.Reference[field.autor.Field.Content[0]].__contribution__.Name}: `:''}${field.titel.Field.Content} ${field.untertitel&&field.untertitel.Field.Content ? `, ${field.untertitel.Field.Content}` : ''}`;
    },
    async toggleState(state) {
      this.searching = true;
      let result = await this.$store.dispatch('post', {
          mode: `/state/${this.$root.logindata.userid}`, 
          params: {state: state, contribution: this.$route.params.id}
      });
      await this.fetchData(); 
      this.searching = false;
    },
    async person_provider(form_field, event) {
      if (!event.target.value || event.target.value == "") {
        form_field.value = [];
        if (this.debounce[form_field.id]) {
          clearTimeout(this.debounce[form_field.id]);
        }
        return;
      }
      if (this.debounce[form_field.id]) {
        clearTimeout(this.debounce[form_field.id]);
      }
      this.debounce[form_field.id] = setTimeout((async()=>{
        form_field.value = await this.$store.dispatch('load', {mode: "/contributions/1/1", params: {
            limit: 5,
            query: event.target.value.replace(/ /g, '+'),
            verbose: "true",
            data: "name|vorname|ort",
            filter: "4|3|8:like|like|like"
        }});
        try {
          form_field.value.Documents.forEach((d)=>{
            d._html = `${d.Data.vorname.Field.Content} ${d.Data.name.Field.Content}${d.Data.ort.Field.Content ? `, ${d.Data.ort.Field.Content}`:''}`
          })
        } catch (error) {
          
        } 
      }).bind(this, form_field, event), 500);
    },
    person_template(field) {
      return `${field.vorname.Field.Content} ${field.name.Field.Content}${field.ort.Field.Content ? `, ${field.ort.Field.Content}` : ''}`;
    },
    prepareValues(_data, _field) {
        // Todo: Translations of configurations 
        if (_data.Template.Fieldtype == "TypologySelect") {

          _data.Field.Content = _data.Field.Content || [];

          if (_data.Template.Fieldname == "genre") {
              return this.$root.categories.genres_parsed;
          }
          if (_data.Template.Fieldname == "medientyp") {
              return this.$root.categories.mediatypes_parsed;
          }
          if (_data.Template.Fieldname == "textsprache") {
            return this.$root.categories.languages_parsed;
          }
        }
        if (_data.Template.Fieldname == "erscheinungsjahr") {
          let d = new Date(_data.Field.Content * 1000);
          _data.Field.Content = d.getFullYear();
        }
        return '';
    },
    async fetchData() {
      this.data = await this.$store.dispatch('load', {realtime: true, mode: `/contribution/${this.$route.params.id}`, params: {verbose: 'true'}});
      if (this.data.error) {
        console.warn(this.data.error);
        this.searching = false;
        return;
      }

      this.form_data = this.data.Data;
      this.form_type = this.data.Contribution.FortemplateName;

      this.form_field = [];
      for (let _field in this.form_data) if (this.form_data.hasOwnProperty(_field)) {

          let _value = this.prepareValues(this.form_data[_field], _field);

          let _type = this.autocomplete_providers[_field] ? 'ajax_provider' : this.form_data[_field].Template.Fieldtype;
          // Overrule of default Form Types, by Name and Id
          _type = this.formfield_exceptions[this.form_data[_field].Template.Fieldname] || _type;
          _type = this.formfield_exceptions[this.form_data[_field].Template.Id] || _type;
          let _label = this.label_exceptions[this.form_data[_field].Template.Id] || _field;
          let _infotext = this.forminfo_exceptions[this.form_data[_field].Template.Fieldname] || false;
          _infotext = this.forminfo_exceptions[this.form_data[_field].Template.Id] || _infotext;

          let _title = this.grouptitle_exception[this.form_data[_field].Template.Id] || false;
          let _divider = this.groupdivider_exception[this.form_data[_field].Template.Id] || false;

          this.form_field.push({
              id        : _field,            
              name      : `editor:label:${_label}`,
              title     : _title ? `editor:title:${_title}` : false,
              divider   : _divider,
              infotext  : _infotext ? `editor:infotext:${_infotext}` : false,
              type      : _type,
              value     : _value,
              provider  : this.autocomplete_providers[_field] || function(){},
              template  : this.autocomplete_templates[_field] || function(){} 
          })
      }
      

      /*this.form_field.forEach((f)=>{
        if (f.type=='hash') {
          this.hashCompare(f, this.form_data[f.id])
        }
        if (f.type=='date') {
          let d = new Date(this.form_data[f.id].Content * 1000);
          this.form_data[f.id].Content = `${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`;
        }
      })*/
      this.searching = false;
    },
    hashCompare(field, content) {
      let _comp = [];
      field.value.forEach((label)=>{
        let _found = false;
        content.Content.forEach((row)=>{
          if (row[1] == label) {
            _comp.push([row[0],row[1]]);
            _found = true;
          }
        })
        if (!_found) {
          _comp.push([null,label]);
        }
      })
      content.Content = _comp;
    },
    async submit() {
      this.searching = true;
      let result = await this.$store.dispatch('post', {
          mode: `/media/${this.$route.params.id}`, 
          params: this.form_data
      });
      this.searching = false;
    },
    close() {
      this.$router.push('/dashboard');
    }
  }
}
</script>
